import { render, staticRenderFns } from "./ProjectTicketComponent.vue?vue&type=template&id=5dfcc4c0&scoped=true"
import script from "./ProjectTicketComponent.vue?vue&type=script&lang=js"
export * from "./ProjectTicketComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectTicketComponent.vue?vue&type=style&index=0&id=5dfcc4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcc4c0",
  null
  
)

export default component.exports